// Tracks correlation ids echoed by the backend (X-Correlation-ID response header,
// set by the CorrelationId middleware). The bug report uses the last *error*
// correlation to hand support a direct handle into Overseer's correlation detail;
// client telemetry tags entries with the last correlation seen for general context.

let lastCorrelationId: string | null = null;
let lastErrorCorrelationId: string | null = null;

export function setLastCorrelationId(id: string | null | undefined): void {
  if (id) lastCorrelationId = id;
}

export function setLastErrorCorrelationId(id: string | null | undefined): void {
  if (id) {
    lastErrorCorrelationId = id;
    lastCorrelationId = id;
  }
}

export function getLastCorrelationId(): string | null {
  return lastCorrelationId;
}

export function getLastErrorCorrelationId(): string | null {
  return lastErrorCorrelationId;
}
